<div style="display: block; text-align: center; margin: auto">
  <div class="chartWrapper">
    <div class="chartAreaWrapper">
      <canvas id = "myChart" height="70"></canvas>
    </div>
  </div>
</div>
<h2>Note: {{nota}}</h2>
<h2>Piano terapeutico: {{terapia}}</h2>
